// Reglas de acceso de un coach según su suscripción (extraídas de Routes.js).

// Fin de la prueba que guardó el back al registrar al coach (payment.trialEndsAt, según TRIAL_DAYS),
// o null si no vino o no es una fecha válida.
export const getTrialEndsAt = (session) => {
    const trialEndsAt = (session?.payment || session?.user?.payment)?.trialEndsAt;
    if (!trialEndsAt) return null;
    const date = new Date(trialEndsAt);
    return isNaN(date.getTime()) ? null : date;
};

// Días que le quedan a la prueba, redondeando hacia arriba (0 si ya terminó).
export const trialDaysLeft = (trialEndsAt, now = new Date()) =>
    Math.max(0, Math.ceil((trialEndsAt.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)));

// Texto del aviso de prueba. Sin trialEndsAt se mantiene el de siempre (mes de prueba).
export const trialNotice = (session, now = new Date()) => {
    const trialEndsAt = getTrialEndsAt(session);
    if (!trialEndsAt) {
        return "Estás disfrutando de tu mes de prueba gratuito con acceso Premium. Selecciona un plan para continuar usando MuyCoach después del periodo de prueba.";
    }
    const date = trialEndsAt.toLocaleDateString("es", { day: "numeric", month: "long", year: "numeric" });
    const days = trialDaysLeft(trialEndsAt, now);
    const left = days === 0 ? "termina hoy" : days === 1 ? "te queda 1 día" : `te quedan ${days} días`;
    return `Tu prueba gratuita con acceso Premium termina el ${date} (${left}). Selecciona un plan para continuar usando MuyCoach después del periodo de prueba.`;
};

// Con payment.trialEndsAt la prueba vence en esa fecha, igual que en el back.
// Sin trialEndsAt (coaches registrados antes): más de 1 mes desde la creación de la cuenta.
export const isTrialExpired = (session, now = new Date()) => {
    const trialEndsAt = getTrialEndsAt(session);
    if (trialEndsAt) return now > trialEndsAt;

    if (!session?.user?.createdAt) return false;

    const createdAt = new Date(session.user.createdAt);
    const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());

    // Si la fecha de creación es anterior a hace 1 mes, el trial expiró
    return createdAt < oneMonthAgo;
};

// Verificar si tiene una suscripción válida (no es free beta o tiene subscriptionId)
export const hasValidSubscription = (session, now = new Date()) => {
    const payment = session.payment || session.user?.payment;

    if (!payment) return false;

    // 1. EL CAMBIO: Si el estado ya es EXPIRED, el periodo de gracia terminó.
    if (payment.status === 'EXPIRED') return false;

    // 2. Si tiene subscriptionId y no está expired, tiene acceso.
    // (Esto incluye el estado CANCELLED durante los 15 días de gracia).
    if (payment.subscriptionId || payment.orderId) return true;

    // 3. Mantener lógica de Free Beta (Trial)
    if (payment.isFreeBeta) return !isTrialExpired(session, now);

    return false;
};

// Ruta a la que hay que mandar al coach, o null si se queda donde está.
// La vuelta de Stripe Checkout (/payment?checkout=success|cancel) nunca se redirige:
// la pantalla de pago muestra la confirmación y después lleva al coach a donde corresponde.
// Solo redirigir a /payment si:
// - Usuario logueado como coach
// - No tiene suscripción válida (free beta expirado o sin payment)
// - No está ya en /payment
export const getPaymentRedirect = (session, pathname, now = new Date(), search = '') => {
    if (pathname === '/payment' && /[?&]checkout=/.test(search)) {
        return null;
    }
    if (session?.isLogged &&
        session?.userType === 'coach' &&
        !hasValidSubscription(session, now) &&
        pathname !== '/payment'
    ) {
        return "/payment";
    } else if (session?.isLogged && session?.userType === 'coach' && hasValidSubscription(session, now) && pathname === '/payment') {
        return "/";
    }
    return null;
};
